export default __webpack_public_path__ + "static/apple-touch-icon-32931b3836287bf9b5098b98e44ccba9.png";